import React, { useState } from 'react'
import Style from './Login.module.css'
import Button from '../../Components/Button/Button';
import Input from '../../Components/Input/Input';
import { LoginAdmin } from '../../API/AdminServices';
import { useHistory } from 'react-router';
import { errorToast, succToast } from '../../Toast/Toast';
const Login = () => {
    const history=useHistory()
    const[userName,setUserName]=useState()
    const[password,setPassword]=useState()

    const LoginHandler=(e)=>{
        e.preventDefault()
        let info={
            user_name:userName,
            password:password
        }
        LoginAdmin(info,(succ)=>{
           if(succ.status===1){
                succToast('با موفقیت وارد شدید')
                localStorage.setItem('electronicStepsAdmin',succ.token)
                setTimeout(()=>history.push('/'),500)
           }           
            else{
                errorToast(succ.message)
            }
        })
    }

    return (
        <div className={Style.PageHolder}>
            <form  className={Style.formHolder}>
                <div className={Style.logoHolder}><img src="/Assets/Images/Logo/logo.png" alt="electronicSteps" /></div>
                <div className={Style.InputHolder}>
                    <Input  inputtype={'text'} placeholder={'نام کاربری'} onChange={e=>setUserName(e.target.value)}/>
                    <Input type={'password'} inputtype={'text'} placeholder={'رمز عبور '} onChange={e=>setPassword(e.target.value)}/>   
                </div>
                <Button ClassBtn={'confirmBtn'} Value={'ورود'} clickhandler={LoginHandler}/>
            </form>
        </div>
    )
}

export default Login
